import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  style: {
    "color": "#015e9e",
    "font-weight": "bold"
  }
};
import { ref } from 'vue';
import { AdminLayout } from '@/views/layout';
import { excludeAlive } from '@/constants/kpi';
import { useMyOrgStore, useAuthorStore } from '@/stores';
import { MgFlexFill } from '@/share/components';
import { AppRouter } from '@/router';

import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { computed, reactive, nextTick, onMounted } from 'vue';
export default {
  __name: 'userConsoleLayout',
  setup(__props) {
    const adminLayoutRef = ref();
    const appRouter = new AppRouter('kpi');
    const router = useRouter();
    const loading = ref(false);
    const myOrgStore = useMyOrgStore();
    const authorStore = useAuthorStore();
    const {
      org
    } = storeToRefs(authorStore);
    const orgId = computed(() => {
      const {
        id = ''
      } = org.value;
      return id || '';
    });
    const authorMenu = ref([{
      title: '修改密码',
      name: 'changeSelfPwd'
    }, {
      title: '退出系统',
      name: 'quit'
    }]);
    const myOrgList = ref([]);
    const menuItems = ref([]);
    appRouter.setMenuChangeListener(menus => {
      menuItems.value = menus || [];
    }, true);
    const handleUpgradeEnterprise = () => {
      router.push({
        path: '/account/upgrade-enterprise'
      });
    };

    //
    // const createMenus = (user, org) => {
    //     const { id: orgId = '' } = org || {};
    //     const { id = '', userId = '' } = user || {};
    //     if (orgId) {
    //         menuItems.value = enterpriseMenus.createMenus(user, org);
    //     } else if (id || userId) {
    //         menuItems.value = userMenus.menus;
    //     }
    // };
    //
    // watch(() => [ authorStore.org, authorStore.user ], (val) => {
    //     const [ curOrg, curUser ] = val;
    //     createMenus(unref(curUser), unref(curOrg));
    // }, { immediate: true, deep: true });

    // 更新菜单数据
    const handleRefreshMenu = () => {};
    const handleAuthorMenuClick = ({
      item,
      user
    }) => {
      console.log('author menu click:', item, ', user:', user);
    };
    const publicMethods = reactive({
      // 更新用户菜单
      'updateAuthorMenus'() {
        const orgId = authorStore.orgId;
        myOrgStore.getMyOrgList(orgId).then(res => {
          myOrgList.value = res || [];
        });
      }
    });
    const resetHistoryRoutes = () => {
      !!adminLayoutRef.value && adminLayoutRef.value.resetHistory();
    };
    const handleOrgLogin = item => {
      const {
        id
      } = item || {};
      if (!id) return;
      resetHistoryRoutes();
      nextTick(() => {
        router.push({
          path: `/org-login/${id}`
        });
      });
    };

    // const handleOrgLogout = () => {
    //     resetHistoryRoutes();
    //     nextTick(() => {
    //         router.push({
    //             path: '/enterprise/org-logout',
    //         });
    //     });
    // };

    onMounted(() => {
      publicMethods.updateAuthorMenus();
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_mg_flex = _resolveComponent("mg-flex");
      return _openBlock(), _createBlock(_unref(AdminLayout), {
        ref_key: "adminLayoutRef",
        ref: adminLayoutRef,
        "app-group": "kpi",
        title: "绩效管理",
        menus: menuItems.value,
        "author-menu": authorMenu.value,
        loading: loading.value,
        methods: _unref(publicMethods),
        "history-route-store-key": "icloud-kpi-sys-routes",
        onRefreshMenu: handleRefreshMenu,
        onAuthorMenuClick: handleAuthorMenuClick,
        "show-footer": true,
        "page-header-class": "sys-page-header",
        "home-tab": {
          showHome: true,
          homeTitle: '首页',
          homePath: '/home'
        },
        "win-tab-bar-props": {
          bkColor: '#f1f1f1'
        },
        "exclude-alive": _unref(excludeAlive)
      }, {
        header: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("span", {
          class: "kpi-header-title"
        }, [_createElementVNode("i", {
          class: "header-icon kpi-sys-logo"
        }), _createElementVNode("span", {
          class: "header-title"
        }, "爱绩效平台——绩效指标管理系统")], -1)]))]),
        "header-extra": _withCtx(() => [!_unref(orgId) ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 0,
          status: "primary",
          mode: "text",
          onClick: handleUpgradeEnterprise
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("升级为企业用户", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        "author-menu-prefix": _withCtx(() => [_createVNode(_component_mg_flex, {
          vertical: "",
          style: {
            "width": "300px"
          },
          align: "center-left"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myOrgList.value, (item, idx) => {
            return _openBlock(), _createBlock(_component_mg_flex, {
              key: `org_item_${idx}`,
              style: {
                "width": "100%",
                "height": "35px"
              },
              align: "center-left",
              "enable-hover": ""
            }, {
              default: _withCtx(() => [_createVNode(_unref(MgFlexFill), {
                style: {
                  "line-height": "35px",
                  "padding": "0 10px"
                }
              }, {
                default: _withCtx(() => [_cache[2] || (_cache[2] = _createTextVNode(" 切换到", -1)), _createVNode(_component_vxe_button, {
                  mode: "text",
                  onClick: () => handleOrgLogin(item)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024);
          }), 128)), _unref(org) && _unref(org).id ? (_openBlock(), _createBlock(_component_mg_flex, {
            key: 0,
            style: {
              "width": "100%",
              "height": "35px"
            },
            align: "center-left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(MgFlexFill), {
              style: {
                "line-height": "35px",
                "padding": "0 10px"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(_unref(org).name), 1)]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        footer: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
          class: "ui-icon icon-sys-logo"
        }, null, -1), _createTextVNode(" 贵州码软件科技有限公司提供技术支持 ", -1)]))]),
        _: 1
      }, 8, ["menus", "author-menu", "loading", "methods", "exclude-alive"]);
    };
  }
};